/**
 * Imports
 */
import {
  signinWebAuth, signupWebAuth, resetPasswordWebAuth, socialAuthorizationWebAuth
} from 'api/webAuth';
import { updateAdditionalInfoApi } from 'api/account';
import { processAuthInfoForAdditionalInfo, authCallback } from 'libs/auth';
import { formatErrorMessage, formatMessage } from 'libs/notice';

/**
 * Declarations
 */
export const PROCESS_AUTH_ONBOARD_START = 'PROCESS_AUTH_ONBOARD_START';
export const PROCESS_AUTH_ONBOARD_END = 'PROCESS_AUTH_ONBOARD_END';
export const ERROR_ONBOARD = 'ERROR_ONBOARD';

/**
 * Actions
 */
export function processOnboardStart(social=false) {
  return ({ type: PROCESS_AUTH_ONBOARD_START, payload: {social: social}});
}

export function processOnboardEnd(payload = {}) {
  return ({ type: PROCESS_AUTH_ONBOARD_END, payload });
}

export function errorOnboard() {
  return ({ type: ERROR_ONBOARD });
}

export function saveAddtionalInfoOnBoard(userInfo, cb = () => {}) {
  return (dispatch) => {
    dispatch(processOnboardStart());
    const { accessToken, ...rest } = userInfo;
    updateAdditionalInfoApi(rest, accessToken)
      .then(() => {
        authCallback({ accessToken });
      })
      .catch((error) => {
        const formattedError = formatErrorMessage(error);
        cb({ message: formattedError });
        dispatch(errorOnboard(error));
      });
  };
}

export function loginOnboard(userInfo = {}, cb = () => {}) {
  return (dispatch) => {
    dispatch(processOnboardStart());
    // api call
    signinWebAuth(userInfo)
      .then((res = {}) => {
        const additionalInfo = processAuthInfoForAdditionalInfo(res);
        dispatch(processOnboardEnd(userInfo));
        cb({ additionalInfo });
      })
      .catch((error = {}) => {
        const errorDescription = error.description || '';
        if (errorDescription.indexOf('A verification email has been sent to your inbox.') !== -1) {
          dispatch(processOnboardEnd(userInfo));
          cb({ recurringLogin: true });
        } else {
          cb({ message: error.description });
          dispatch(errorOnboard(error));
        }
      });
  };
}

export function loginOnboardRecurring(userInfo, cb = () => {}) {
  return (dispatch) => {
    // api call
    signinWebAuth(userInfo)
      .then((res) => {
        const additionalInfo = processAuthInfoForAdditionalInfo(res);
        dispatch(processOnboardEnd(userInfo));
        cb({ additionalInfo, closeEmailVerifyModal: true });
      })
      .catch(() => {
        cb({ errorRecurring: true });
      });
  };
}

export function signupOnboard(userInfo = {}, cb = () => {}) {
  return (dispatch) => {
    dispatch(processOnboardStart());
    // api call
    signupWebAuth(userInfo)
      .then(() => {
        dispatch(processOnboardEnd(userInfo));
        cb({ recurringLogin: true });
      })
      .catch((error = {}) => {
        cb({ message: error.description });
        dispatch(errorOnboard(error));
      });
  };
}

export function continueWithSocial(connection, userInfo = {}) {
  return (dispatch) => {
    dispatch(processOnboardStart(true));
    // api call
    socialAuthorizationWebAuth(connection, userInfo)
      .then(() => {
        dispatch(processOnboardEnd());
      });
  };
}

export function resetEmailOnBoard(userInfo = {}, cb = () => {}) {
  return (dispatch) => {
    dispatch(processOnboardStart());
    // api call
    resetPasswordWebAuth(userInfo)
      .then((res) => {
        cb({ message: formatMessage('resetEmail.action.email.sent'), closeResetModal: true });
        dispatch(processOnboardEnd(userInfo));
      })
      .catch((error) => {
        cb({ message: error.description });
        dispatch(errorOnboard(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/onBoard.js